import { render, staticRenderFns } from "./down.vue?vue&type=template&id=b71a4170&scoped=true&"
import script from "./down.vue?vue&type=script&lang=ts&"
export * from "./down.vue?vue&type=script&lang=ts&"
import style0 from "./down.vue?vue&type=style&index=0&id=b71a4170&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b71a4170",
  null
  
)

export default component.exports